import React, { createContext, useContext, useState } from "react";
import { EnquiryModal } from "./EnquiryModal";

const EnquiryContext = createContext();

export const useEnquiry = () => {
  const context = useContext(EnquiryContext);
  if (!context) {
    // Return a no-op function if context is not available
    return { openEnquiryModal: () => {}, closeEnquiryModal: () => {} };
  }
  return context;
};

export const EnquiryProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enquiryType, setEnquiryType] = useState("general");

  const openEnquiryModal = (type = "general") => {
    setEnquiryType(type);
    setIsModalOpen(true);
  };

  const closeEnquiryModal = () => {
    setIsModalOpen(false);
  };

  return (
    <EnquiryContext.Provider value={{ openEnquiryModal, closeEnquiryModal }}>
      {children}
      <EnquiryModal 
        isOpen={isModalOpen} 
        onClose={closeEnquiryModal} 
        enquiryType={enquiryType}
      />
    </EnquiryContext.Provider>
  );
};
